import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import {
  FORMAT_TIME_ONLY,
  FORMAT_WEEKDAY_DATE_MINI,
} from 'utils/helpers/datetime';
import { getDateObjectFromReservation } from 'utils/helpers/reservations';
import {
  getNextUpcomingReservation,
  getUpcomingBooking,
} from 'redux/selectors/current_booking';
import { getSegmentEntities } from 'redux/selectors/sealink/segments';
import useGetVehicles from '../booking_summary/ferry/use_get_vehicles';
import View from './view';

const FerryOrTransfer = () => {
  const booking = useSelector(getUpcomingBooking);
  const segments = Object.values(useSelector(getSegmentEntities));
  const upcomingReservation = useSelector(getNextUpcomingReservation);

  // Get name, prefer to use the route name defined in CMS segments
  let name = upcomingReservation.route;
  const routeSegment = segments.find(
    (segment) => segment.qt_route_id === upcomingReservation.route_id
  );

  if (routeSegment) {
    name = `${routeSegment.departure} to ${routeSegment.arrival}`;
  }

  // Get date
  const reservationDate = getDateObjectFromReservation(upcomingReservation);
  const travelDate = format(reservationDate, FORMAT_WEEKDAY_DATE_MINI);
  const travelTime = format(reservationDate, FORMAT_TIME_ONLY);
  const date = `${travelDate}, ${travelTime}`;

  // Get vehicle
  const vehicles = [];
  const detailedVehicles = useGetVehicles(booking);

  detailedVehicles.forEach((vehicle) => {
    // Ignore if the vehicle object does not have a name, it could be a luggage item
    if (!vehicle.name?.trim()) {
      return;
    }

    const text = `${vehicle.name}, ${vehicle.year ? `${vehicle.year},` : ''} ${
      vehicle.length
    }m`;

    vehicles.push({
      text,
      icon: vehicle.icon,
    });
  });

  return <View name={name} date={date} vehicles={vehicles} />;
};

export default FerryOrTransfer;
